import { render, staticRenderFns } from "./PromotionAssorted.vue?vue&type=template&id=97dc0b1e&scoped=true&"
import script from "./PromotionAssorted.vue?vue&type=script&lang=js&"
export * from "./PromotionAssorted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dc0b1e",
  null
  
)

export default component.exports